export default __webpack_public_path__ + "static/media/twitter-mono.4ea22dec.svg";